/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react'
import {
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Dropdown,
  Menu,
  message,
} from 'antd'
import moment from 'moment'
import { marginAnalysisEventPlanner } from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import { downloadFile } from 'reports/dm/reportCall'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import JcTmpErrorContext from 'context/JcTmpErrorContext'
import { connect } from 'react-redux'
import { getFinalData } from 'marginanalysis/utils'

const EventPlannerDialog = props => {
  const {
    targetInfo,
    visible,
    onOk,
    onClose,
    whatIf = false,
    lostType = 1,
    isEventPlanner = false,
  } = props
  const marginContext = useContext(MarginAnalysisContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const finalData = getFinalData(marginContext, whatIf, isEventPlanner)
  const { scenario = {} } = finalData.request || {}

  const { unitid, startdate, enddate, unitId } = scenario
  const { setError } = useContext(ErrorContext)
  const [eventDuration, setEventDuration] = useState(24)
  const [startDate, setStartDate] = useState(
    (startdate && moment(startdate)) || moment()
  )
  const [endDate, setEndDate] = useState(
    (enddate && moment(enddate)) || moment()
  )

  const generatePdf = (reportType = 'PDF', background = false) => {
    if (!finalData.request) {
      message.warn('Please, Retrieve Data.')
      return
    }

    const reqData = {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      eventDuration: eventDuration,
      emktId: unitid || unitId,
      reportType,
      background,
      lostType,
    }

    setSpinning(true)
    marginAnalysisEventPlanner(targetInfo)(reqData).fork(setError, d => {
      setSpinning(false)
      const error = d.ERRORS || []
      if (!background && !isErrorContains(error))
        downloadFile(targetInfo)(d.fileName)
      else if (error.length > 0) {
        setTmpError(error)
      }
      onClose()
    })
  }

  return (
    <Modal
      visible={visible}
      onOk={onOk}
      onCancel={onClose}
      title="Event Planner"
      height={500}
      width={800}
      footer={false}
      onClose={onClose}
      destroyOnClose
      maskClosable
      closable
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '170px 150px 150px 100px',
          gridGap: '5px',
        }}
      >
        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Earliest Event Start Date:
        </div>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={startDate}
          onChange={setStartDate}
          disabled={spinning}
        />
        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Event Duration (Hrs):
        </div>
        <InputNumber
          min={0}
          value={eventDuration}
          onChange={setEventDuration}
          disabled={spinning}
        />
        <div
          style={{
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Latest Event End Date:
        </div>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={endDate}
          onChange={setEndDate}
          disabled={spinning}
        />
        <div />
        <div />
        <Button
          type="primary"
          onClick={_ => generatePdf('PDF')}
          loading={spinning}
        >
          PDF Format
        </Button>
        <Button
          type="primary"
          onClick={_ => generatePdf('CSV')}
          loading={spinning}
        >
          CSV Format
        </Button>
        <Dropdown
          placement="bottomLeft"
          overlay={
            <Menu>
              <Menu.Item onClick={_ => generatePdf('PDF', true)}>PDF</Menu.Item>
              <Menu.Item onClick={_ => generatePdf('CSV', true)}>CSV</Menu.Item>
            </Menu>
          }
        >
          <Button
            type="ghost"
            style={{ gridColumnEnd: 'span 2' }}
            loading={spinning}
          >
            Generate in Background
          </Button>
        </Dropdown>
      </div>
    </Modal>
  )
}

export default EventPlannerDialog
